import toInt from 'validator/lib/toInt';
import whitelist from 'validator/lib/whitelist';

export const sanitizeDecimal =
    (precision: number) =>
    (value: string): string => {
        const whitelisted = value.replaceAll(/[^\d.]/g, '');
        if (whitelisted === '.') return '0.';
        const dotIndex = whitelisted.indexOf('.');
        const additionalDotIndex = whitelisted.indexOf('.', dotIndex + 1);
        let clean = whitelisted;

        if (additionalDotIndex > -1) {
            clean = whitelisted.slice(0, additionalDotIndex);
        }
        const [left, right] = clean.split('.');
        if (left === '') return left;
        const decimal = dotIndex > -1 ? `.${right.slice(0, precision)}` : '';

        return `${left}${decimal}`;
    };

export const sanitizeNatural = (value: string): string => {
    const clean = whitelist(value, '0-9');

    return Number.isNaN(toInt(clean)) ? '' : clean;
};

export const sanitizeInteger = (value: string): string => {
    const clean = whitelist(value, '-0-9');
    if (clean[0] === '-' && clean.length === 1) return clean;

    return String(Number.isNaN(toInt(clean)) ? '' : toInt(clean));
};

export const usernameSanitizer = (value: string) =>
    whitelist(value, 'a-zA-Z0-9\\_\\.\\+\\-');

export const sanitizeTaxRate = (value: string): string => {
    const whitelisted = value.replaceAll(/[^\d.]/g, '');
    if (whitelisted === '.') return '0.';
    const dotIndex = whitelisted.indexOf('.');
    const additionalDotIndex = whitelisted.indexOf('.', dotIndex + 1);
    let clean = whitelisted;

    if (additionalDotIndex > -1) {
        clean = whitelisted.slice(0, additionalDotIndex);
    }
    const [left, right] = clean.split('.');
    if (left === '') return left;
    const decimal = dotIndex > -1 ? `.${right.slice(0, 2)}` : '';

    return `${left.slice(0, 2)}${decimal}`;
};
